import { render, staticRenderFns } from "./corporate-risk-detail.vue?vue&type=template&id=7c31ee7e&scoped=true"
import script from "./corporate-risk-detail.vue?vue&type=script&lang=js"
export * from "./corporate-risk-detail.vue?vue&type=script&lang=js"
import style0 from "./corporate-risk-detail.vue?vue&type=style&index=0&id=7c31ee7e&prod&lang=scss&scoped=true"
import style1 from "./corporate-risk-detail.vue?vue&type=style&index=1&id=7c31ee7e&prod&scoped=true&lang=css"
import style2 from "./corporate-risk-detail.vue?vue&type=style&index=2&id=7c31ee7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c31ee7e",
  null
  
)

export default component.exports